import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../Typography/Typography.js';
import { ButtonVariant } from '../../utils/buttonStyles.js';
import { getDialogHeaderStyles, getDialogHeaderCloseStyles, getDialogTitleStyles, getDialogHeaderTitleStyles } from './DialogHeaderStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { ButtonIcon } from '../ButtonIcon/ButtonIcon.js';

const CloseButton = _ref => {
  let {
    onClose,
    closeAriaLabel
  } = _ref;
  return jsx(ButtonIcon, {
    onClick: onClose,
    icon: IconNames.CLOSE,
    variant: ButtonVariant.TEXT,
    "aria-label": closeAriaLabel,
    ariaDescribedby: closeAriaLabel !== null && closeAriaLabel !== void 0 ? closeAriaLabel : 'Close dialog',
    children: closeAriaLabel !== null && closeAriaLabel !== void 0 ? closeAriaLabel : 'Close dialog'
  });
};
const DialogHeader = _ref2 => {
  let {
    title,
    children,
    showClose,
    closeAriaLabel,
    closePosition = 'right',
    onClose,
    ...rest
  } = _ref2;
  return jsxs("header", {
    css: getDialogHeaderStyles,
    ...rest,
    children: [showClose && jsx("div", {
      css: getDialogHeaderCloseStyles,
      children: closePosition === 'left' && jsx(CloseButton, {
        onClose: onClose,
        closeAriaLabel: closeAriaLabel,
        position: closePosition
      })
    }), jsx("div", {
      css: getDialogTitleStyles,
      children: children || jsx(Typography, {
        component: "h3",
        variant: "heading3",
        css: getDialogHeaderTitleStyles,
        children: title
      })
    }), showClose && jsx("div", {
      css: getDialogHeaderCloseStyles,
      children: closePosition === 'right' && jsx(CloseButton, {
        onClose: onClose,
        closeAriaLabel: closeAriaLabel,
        position: closePosition
      })
    })]
  });
};

export { DialogHeader };
//# sourceMappingURL=DialogHeader.js.map
